var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc rich text
 * @author liwensheng
 */
import CustomElement from '../shapes/CustomElement';
import Text from '../shapes/Text';
import RichObj from './rich-obj';
var RichText = /** @class */ (function (_super) {
    __extends(RichText, _super);
    function RichText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'richText';
        return _this;
    }
    RichText.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { rich: true });
    };
    RichText.prototype.getObservedAttr = function () {
        return ['text', 'textAlign', 'textBaseline', 'x', 'y', 'fontSize'];
    };
    RichText.prototype.onAttrChange = function (key, newvalue, oldvalue) {
        _super.prototype.onAttrChange.call(this, key, newvalue, oldvalue);
        if (key === 'text') {
            this._richObj = new RichObj(this.attr);
        }
    };
    RichText.prototype.render = function () {
        if (!this._richObj) {
            return;
        }
        var rootNode = this._richObj.node;
        if (rootNode.type === 'text') {
            return new Text(__assign({}, this.attr));
        }
        this._richObj.layout();
        return rootNode.render();
    };
    return RichText;
}(CustomElement));
export default RichText;
